import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
  Container,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { toast, Toaster } from "react-hot-toast";
import { getOptimizedData } from "../../Utility/utility";
import Platforms from "../../constants/platforms.json";
import AdvanceSearchForm from "../../component/AdvanceSearchForm/AdvanceSearchForm";
import OpenaiResult from "../../component/OpenaiResult/OpenaiResult";

const AnalysedProducts = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const [promptsList, setPromptsList] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({});

  const showDetailsModalHandler = () => setShowDetailsModal((value) => !value);

  const handleView = (productPrompt) => {
    setSelectedPrompt(productPrompt);
    showDetailsModalHandler();
  };

  const [searchByPlatform, setSearchByPlatform] = useState({
    platformAction: false,
    selectedPlatform: "",
    scrapedProductData: {},
    userID: "",
  });

  const [loader, setLoader] = useState(false);
  const [openaiResult, setOpenaiResult] = useState({});
  const [show, setShow] = useState({
    promptSaved: true,
    advanceSearchForm: false,
    openaiResult: false,
  });

  async function handleAdvanceForm(values) {
    const response = await getOptimizedData(values, userID);
    toast.success(
      "Your data has been optimized and saved automatically"
    );

    setOpenaiResult(response);
    setLoader(false);
    setShow({
      promptSaved: false,
      advanceSearchForm: false,
      openaiResult: true,
    });
  }

  useEffect(() => {
    (async () => {
      const { data } = await axiosOpen.get(`prompt/userprompts/${userID}`);
      const modifiedResponse = data?.prompts
        ? structuredClone(data.prompts)
        : [];
      modifiedResponse.length > 0 &&
        modifiedResponse.forEach((product) => {
          product.promptrequest.title = product.promptrequest.title.trim();
          product.promptresponse.title = product.promptresponse.title.trim();

          product.promptrequest.description =
            product.promptrequest.description.trim();
          product.promptresponse.description =
            product.promptresponse.description.trim();

          product.promptrequest.features =
            (product.promptrequest?.features &&
              product.promptrequest.features
              .replace("\n\n-", "")
                .replace("\n\n", "")
                .replace(/\n\n/g, "<br/>")
                .replace(/\n•/g, "<br/>")
                .replace("1. ", "")
                .replace(/\n[0-9]./g, "<br/>")
                .replace(/\n-/g, "<br/>")
                .split("<br/>")) ||
            "NA";

          product.promptresponse.features =
            (product.promptresponse?.features &&
              product.promptresponse.features
              .replace("\n\n-", "")
                .replace("\n\n", "")
                .replace(/\n\n/g, "<br/>")
                .replace(/\n•/g, "<br/>")
                .replace("1. ", "")
                .replace(/\n[0-9]./g, "<br/>")
                .replace(/\n-/g, "<br/>")
                .split("<br/>")) ||
            "NA";
        });
      setPromptsList(modifiedResponse);
    })();
  }, [show.promptSaved]);

  function handlePlatformAction(value, data) {
    setSearchByPlatform({
      selectedPlatform: value,
      scrapedProductData: data.promptrequest,
      userID: data.userid,
    });
    setShow({
      promptSaved: false,
      advanceSearchForm: true,
      openaiResult: false,
    });
  }

  function handleCompletion() {
    setShow({
      promptSaved: true,
      advanceSearchForm: false,
      openaiResult: false,
    });
  }

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      {show.promptSaved && (
        <div className="analysed-products-page">
          <div className="analysed-products-wrapper bg-white">
            <>
              <Table
                striped
                hover
                responsive
                className="analysed-product-table"
              >
                <thead>
                  <tr>
                    <th>Platform</th>
                    <th>Title</th>
                    <th>ASIN</th>
                    <th>Description</th>
                    <th>Features</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {promptsList.length > 0 &&
                    promptsList.map((product) => (
                      <tr key={product._id}>
                        <td className="text-capitalize">{product.platform}</td>
                        <td>{`${product.promptrequest.title.slice(
                          0,
                          15
                        )}...`}</td>
                        <td>
                          {product?.asin ? (
                            <a
                              href={product.link}
                              target="_blank"
                              className="text-decoration-none"
                            >
                              {product.asin}
                            </a>
                          ) : (
                            "NA"
                          )}
                        </td>
                        <td>{`${product.promptrequest.description.slice(
                          0,
                          15
                        )}...`}</td>
                        <td>{`${product.promptrequest.features[0].slice(
                          0,
                          15
                        )}...`}</td>
                        <td>
                          <div className="d-flex gap-2 justify-content-center align-items-center">
                            <Button
                              className="font-size-secondary"
                              onClick={() => handleView(product)}
                            >
                              VIEW
                            </Button>
                            <Dropdown
                              onSelect={(value) =>
                                handlePlatformAction(value, product)
                              }
                            >
                              <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                              >
                                Platform
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {Platforms.length > 0 &&
                                  Platforms.map(({ name }) => (
                                    <Dropdown.Item
                                      eventKey={name}
                                      className="text-capitalize"
                                    >
                                      {name}
                                    </Dropdown.Item>
                                  ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <Modal
                show={showDetailsModal}
                onHide={showDetailsModalHandler}
                className="custom-modal"
              >
                <Modal.Header closeButton className="border-0">
                  <Modal.Title>Product Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <Tabs
                    defaultActiveKey="unoptimized-data"
                    id="justify-tab-example"
                    className="mb-3 custom-tab"
                    justify
                  >
                    <Tab eventKey="unoptimized-data" title="Unoptimized Data">
                      <Container>
                        <Row>
                          <Col className="mb-2">
                            <b>Product Title:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.promptrequest?.title}
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-2">
                            <b>ASIN:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.asin || "NA"}
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-2">
                            <b>Product Description:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.promptrequest?.description}
                          </Col>
                        </Row>

                        <Row>
                          <Col className="mb-2">
                            <b>Product Features:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            <ul>
                              {selectedPrompt?.promptrequest?.features.length >
                                0 &&
                                selectedPrompt?.promptrequest?.features.map(
                                  (feature) => <li>{feature}</li>
                                )}
                            </ul>
                          </Col>
                        </Row>
                      </Container>
                    </Tab>
                    <Tab eventKey="optimized-data" title="Optimized Data">
                      <Container>
                        <Row>
                          <Col className="mb-2">
                            <b>Product Title:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.promptresponse?.title}
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-2">
                            <b>ASIN:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.asin || "NA"}
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-2">
                            <b>Product Description:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            {selectedPrompt?.promptresponse?.description}
                          </Col>
                        </Row>

                        <Row>
                          <Col className="mb-2">
                            <b>Product Features:</b>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-3">
                            <ul>
                              {selectedPrompt?.promptresponse?.features.length >
                                0 &&
                                selectedPrompt?.promptresponse?.features.map(
                                  (feature) => <li>{feature}</li>
                                )}
                            </ul>
                          </Col>
                        </Row>
                      </Container>
                    </Tab>
                  </Tabs>
                </Modal.Body>
              </Modal>
            </>
          </div>
        </div>
      )}

      {show.advanceSearchForm && (
        <AdvanceSearchForm
          scrapedData={searchByPlatform.scrapedProductData}
          selectedPlatform={searchByPlatform.selectedPlatform}
          userID={searchByPlatform.userID}
          handleAdvanceForm={handleAdvanceForm}
          loader={loader}
          setLoader={setLoader}
        />
      )}

      {show.openaiResult && (
        <OpenaiResult
          openaiProductData={openaiResult}
          handleCompletion={handleCompletion}
          setShow={setShow}
        />
      )}
    </>
  );
};

export default AnalysedProducts;
